// extracted by mini-css-extract-plugin
module.exports = {"header":"header-fbGf2H0M","header_bar":"header_bar-23NPMJf0 clearfix","box":"box-3KCf3tvP","user":"user-1jmK4bZs","search":"search-3fd9os2h"};